import { Injectable } from '@angular/core';
import { ComponentStore, tapResponse } from '@ngrx/component-store';
import { BreakPointService } from '@woolworthsnz/styleguide';
import { Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

export interface MealPlanShortlistState {
	isNarrowView: boolean;
	showDetails: boolean;
	showOverlayLeft: boolean;
	showOverlayRight: boolean;
}

export const defaultState = {
	isNarrowView: true,
	showDetails: false,
	showOverlayLeft: false,
	showOverlayRight: true,
};

@Injectable()
export class MealPlanShortlistStore extends ComponentStore<MealPlanShortlistState> {
	/**
	 * Selectors
	 */
	public readonly selectState$: Observable<MealPlanShortlistState> = this.select((state) => state);

	/**
	 * Updaters
	 */
	public readonly updateIsNarrowView = this.updater((state: MealPlanShortlistState, isNarrowView: boolean) => ({
		...state,
		isNarrowView,
		showDetails: !isNarrowView ? false : state.showDetails,
	}));

	public readonly updateShowDetails = this.updater((state: MealPlanShortlistState, showDetails: boolean) => ({
		...state,
		showDetails,
	}));

	public readonly updateShowOverlay = this.updater(
		(state: MealPlanShortlistState, showOverlays: { showOverlayLeft: boolean; showOverlayRight: boolean }) => ({
			...state,
			...showOverlays,
		})
	);

	/**
	 * Effects
	 */
	public readonly handleViewportChange = this.effect(() =>
		this.breakpointService.isSmallDevice$.pipe(
			distinctUntilChanged(),
			tapResponse(
				(isSmallDevice: boolean) => this.updateIsNarrowView(isSmallDevice),
				() => {
					/* fail silently */
				}
			)
		)
	);

	constructor(private breakpointService: BreakPointService) {
		super(defaultState);
	}
}
